import { LineItemStatus } from '../../../apis/graphql/types';
import { Option } from '../../../components/types';
import { CAMPAIGN_TIMEZONE_COPY, DEFAULT_CAMPAIGN_TIMEZONE } from '../../../constants';
import { statusFormatter } from '../../formatters/text';

type LineItemWithStatus = { status?: string | null };

export const isAllowedCampaignTimezone = (
  timezone: string | null | undefined,
  allowedTimezones: readonly Option[]
): boolean => !!timezone && allowedTimezones.some(({ value }) => value === timezone);

export const resolveEffectiveCampaignTimezone = ({
  campaignTimezone,
  adAccountTimezone,
}: {
  campaignTimezone?: string | null;
  adAccountTimezone?: string | null;
}): string => campaignTimezone || adAccountTimezone || DEFAULT_CAMPAIGN_TIMEZONE;

export const isCampaignTimezoneInherited = ({
  campaignTimezone,
  adAccountTimezone,
}: {
  campaignTimezone?: string | null;
  adAccountTimezone?: string | null;
}): boolean => !campaignTimezone && !!adAccountTimezone;

export const getCampaignTimezoneLabel = (timezone: string | null | undefined): string =>
  statusFormatter(timezone || '');

export const hasNonDraftLineItems = (lineItems?: readonly LineItemWithStatus[] | null): boolean =>
  !!lineItems?.some(({ status }) => status !== LineItemStatus.Draft);

type CampaignTimezoneEditabilityParams = {
  isFullAllowlistEnabled: boolean;
  isLocked: boolean;
  hasUpdateCampaignPermission: boolean;
  isReadOnly?: boolean;
  hasNonDraftLineItems?: boolean;
};

export const getCampaignTimezoneReadOnlyReason = ({
  isFullAllowlistEnabled,
  isLocked,
  hasUpdateCampaignPermission,
  isReadOnly = false,
  hasNonDraftLineItems: hasNonDraftLineItemsParam = false,
}: CampaignTimezoneEditabilityParams): string | null => {
  if (isLocked) return CAMPAIGN_TIMEZONE_COPY.lockedTooltip;
  if (hasNonDraftLineItemsParam) return CAMPAIGN_TIMEZONE_COPY.nonDraftLineItemsTooltip;
  if (!isFullAllowlistEnabled) return CAMPAIGN_TIMEZONE_COPY.phaseOneTooltip;
  if (!hasUpdateCampaignPermission) return CAMPAIGN_TIMEZONE_COPY.noPermissionTooltip;
  if (isReadOnly) return CAMPAIGN_TIMEZONE_COPY.readOnlyTooltip;

  return null;
};

export const isCampaignTimezoneEditable = (params: CampaignTimezoneEditabilityParams): boolean =>
  getCampaignTimezoneReadOnlyReason(params) === null;
